
















import { Component, Prop, Vue } from 'vue-property-decorator';

interface IOption {
  text: string;
  value: string;
}

@Component
export default class SelectComponent extends Vue {
  @Prop(String) public readonly defaultSelection!: string;
  @Prop({ default: 'Choose', type: String })
  public readonly defaultOptionText!: string;
  @Prop({ default: () => [], type: Array }) public readonly options!: IOption[];
  @Prop(String) public readonly value!: string;
}
